<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>处理任务</el-breadcrumb-item>
      <el-breadcrumb-item>我的任务</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="queryInfo.query"
            @clear="handleCurrentChange(1);"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                handleCurrentChange(1);
              "
            ></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="4" :offset="12">
          <el-button
            type="primary"
            plain
            style="position:absolute;right:10px;"
            @click="gotoTodoList"
          >待领取任务列表</el-button>
        </el-col>-->
      </el-row>

      <el-table :data="datalist" stripe border style="width: 100%" v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="data_id" label="数据编号" min-width="100"></el-table-column>
        <el-table-column prop="data_name" label="数据名称" min-width="100"></el-table-column>
        <el-table-column prop="age" label="年龄" min-width="60"></el-table-column>
        <el-table-column prop="data_dimen" label="数据维度" min-width="100"></el-table-column>
        <el-table-column prop="data_space" label="物理间距" min-width="200"></el-table-column>
        <el-table-column prop="coordinate" label="起点坐标" min-width="280"></el-table-column>
        <el-table-column label="下载数据" min-width="80">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="downloadOriginalData(scope.row.data_id)">
              <i class="el-icon-download"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="upload_user" label="上传用户" width="100"></el-table-column>
        <el-table-column label="数据上传时间" min-width="130">
          <template v-slot="scope">{{ scope.row.upload_time }}</template>
        </el-table-column>
        <el-table-column label="AI建模" min-width="80">
          <template v-slot="scope">
            <span v-if="scope.row.ai_status === '0'">未运行</span>
            <span v-if="scope.row.ai_status === '1'">计算中</span>
            <span v-if="scope.row.ai_status === '2'">
              <el-button size="mini" type="primary" @click="downloadAIData(scope.row.data_id)">
                <i class="el-icon-download"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="AI完成时间" min-width="140">
          <template v-slot="scope">
            <span v-if="scope.row.ai_finish_time === null">未完成</span>
            <span v-if="scope.row.ai_finish_time !== null">{{ scope.row.ai_finish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传" min-width="80">
          <template slot="header">
            <span style="cursor:pointer;" @click="dialogVisible=true">
              上传
              <i class="el-icon-question" style="font-size:14px;"></i>
            </span>
          </template>
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="function(file) {return uploadSegData(file,scope.row.data_id);}"
                :show-file-list="false"
                :before-upload="checkUploadZip"
                style="display:inline;"
              >
                <el-button size="mini" type="primary" icon="el-icon-upload2"></el-button>
              </el-upload>
            </span>
            <span v-if="scope.row.finish_time !== null">已完成</span>
          </template>
        </el-table-column>
        <el-table-column label="结果上传时间" min-width="140">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">无</span>
            <span v-if="scope.row.finish_time !== null">{{ scope.row.finish_time }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" class="tipdialog">
      <p>请上传一个zip压缩包，里面包含8个STL模型，文件命名规则如下：</p>
      <p>肺动脉： PA.stl</p>
      <p>左心房肺静脉：LA.stl</p>
      <p>上腔静脉：SVC.stl</p>
      <p>主动脉：AO.stl</p>
      <p>右心房：RA.stl</p>
      <p>右心室：RV.stl</p>
      <p>左心室：LV.stl</p>
      <p>心包：EE.stl</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传" :visible.sync="uploadDialogVisible" width="25%" @close="interuptUpload">
      <div style="text-align:center;">
        <el-progress
          type="circle"
          :percentage="uploadDiag.progressPercent"
          style="margin-left:20px;"
        ></el-progress>
        <h5>{{uploadDiag.text}}</h5>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      uploadDialogVisible: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5,
      },
      datalist: [],
      total: 0,
      uploadDiag: {
        progressPercent: 0,
        text: "正在上传",
      },
      source: null,
    };
  },
  methods: {
    async getDataList() {
      this.loading = true;
      const { data } = await this.$http.post("data/mytodolist", {
        queryinfo: this.queryInfo,
      });
      if (data.status === 100) {
        this.datalist = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getDataList();
    },
    async downloadOriginalData(data_id) {
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "/data/dicomzip/" + data_id;
    },
    async downloadAIData(data_id) {
      this.$message({ message: "正在生成压缩包", type: "success" });
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "/data/aistl/" + data_id + "/11111111";
    },
    checkUploadZip(file) {
      if (file.name.endsWith(".zip") === false) {
        this.$message({
          message: "请上传zip格式压缩包",
          type: "error",
        });
        return false;
      }
      if (file.size > 100 * 1024 * 1024) {
        this.$message({
          message: "文件大小不超过100m",
          type: "error",
        });
        return false;
      }
    },
    async uploadSegData(file, id) {
      let formdata = new FormData();
      formdata.append("zipfile", file.file);
      formdata.append("dataid", id);
      this.$message({
        type: "warning",
        message: "数据正在上传",
      });
      this.source = this.$http.CancelToken.source();
      const config = {
        "Content-Type": "multipart/form-data",
        cancelToken: this.source.token,
        onUploadProgress: (progressEvent) => {
          this.uploadDiag.progressPercent = Number(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
          );
          if (this.uploadDiag.progressPercent === 100)
            this.uploadDiag.text = "正在解析";
        },
      };
      this.uploadDialogVisible = true;
      this.uploadDiag.progressPercent = 0;
      this.uploadDiag.text = "正在上传";
      const { data } = await this.$http.post(
        "data/uploadstl",
        formdata,
        config
      );
      this.uploadDialogVisible = false;
      if (data.status === 100) {
        this.$message({
          type: "success",
          message: data.data,
        });
        this.getDataList();
      }
    },
    interuptUpload() {
      if (this.uploadDiag.progressPercent < 100) {
        this.source.cancel();
      }
    },
  },
  created() {
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
</style>
